<template>
<div>
  <Dialog 
    :closeOnEscape="false"
    :closable="false"
    v-model:visible="showDialogPrint" 
    :style="{ width: '95vw', height: '95vh' }"
    :maximizable="true"
    header="Comprobante de Reservación">
    
    <iframe 
        v-if="pdfUrl"
        :src="pdfUrl" 
        style="width: 100%; height: 80vh; border: none;">
    </iframe>
    
    <Loading v-if="isLoading" />

    <template #footer>
        <div style="display: flex; width: 100%;" class="mt-2">
            <div style="flex:1; display: flex; justify-content: flex-start; align-items: center;">
                <Button 
                    class="p-button-sm p-button-outlined p-button-danger" 
                    label="CERRAR" 
                    @click="closeDialog"
                    icon="fas fa-times" />
            </div>
            <div style="flex:1; display: flex; justify-content: flex-end; align-items: center; gap: 12px;">
                <Button 
                    class="p-button-sm p-button-outlined p-button-primary" 
                    label="DESCARGAR PDF" 
                    @click="downloadPdf"
                    icon="fas fa-file-pdf" />
                <Button 
                    class="p-button-sm p-button-primary" 
                    label="IMPRIMIR" 
                    @click="printPdf"
                    icon="fas fa-print" />
            </div>
        </div>
    </template>
  </Dialog>
</div>
</template>

<script>
    import apiService from '../../../services/apiService';
    import Loading from '../../../components/templates/Loading.vue';

    export default {
        components: {
            Loading
        },
        props:{
            data: {
                type: Object,
                default: null,
            },
            load: {
                type: Boolean,
                default: false,
            }
        },
        data(){
            return {
                isLoading: false,
                showDialogPrint: false,
                pdfUrl: null,
                pdfBlob: null,
            }
        },
        watch: {
            load(newVal) {
                if (newVal && this.data?.rId) {
                    this.showDialogPrint = true;
                    this.loadPdf();
                }
            },
            showDialogPrint(newVal) {
                if (!newVal) {
                    this.closeDialog();
                }
            }
        },
        mounted(){
            this.showDialogPrint = this.load;
            if (this.load && this.data?.rId) {
                this.loadPdf();
            }
        },
        methods: {
            async loadPdf() {
                if (!this.data?.rId) return;
                
                try {
                    this.isLoading = true;
                    const blob = await apiService.Reservation.ticket(this.data.rId);
                    this.pdfBlob = blob;
                    this.pdfUrl = window.URL.createObjectURL(blob);
                    this.isLoading = false;
                } catch (error) {
                    this.isLoading = false;
                    this.FormRequestFail(error);
                }
            },
            closeDialog(){
                // Limpiar el URL del blob
                if (this.pdfUrl) {
                    window.URL.revokeObjectURL(this.pdfUrl);
                    this.pdfUrl = null;
                    this.pdfBlob = null;
                }
                this.showDialogPrint = false;
                this.$emit('handleClosePrint', '');
            },
            downloadPdf(){
                if (!this.pdfBlob) return;
                
                // Crear nombre del archivo
                const filename = `reserva_nro_${this.data.rId}_${this.data.rDate}.pdf`;
                
                // Descargar el PDF
                const link = document.createElement('a');
                link.href = this.pdfUrl;
                link.download = filename;
                link.click();
            },
            printPdf(){
                if (!this.pdfUrl) return;
                
                // Abrir en nueva ventana solo para imprimir
                const printWindow = window.open(this.pdfUrl);
                if (printWindow) {
                    printWindow.onload = () => {
                        printWindow.print();
                    };
                }
            }
        }
    }
</script>